import "../pages.scss"
import { PresentacionesState } from '../../context/presentaciones/PresentacionesState';
import Datatable from "./presentacionesTable/Datatable"

const PresentacionesPage = () => {
  return (
    <>
      <PresentacionesState>
        <Datatable />
      </PresentacionesState>
    </>
  )
}

export default PresentacionesPage